import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Icon from '../components/Icon'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import ContentBlocks from '../components/ContentBlocks'
import ScrollTo from '../components/ScrollTo'
import Related from '../components/Related'


import Asset from '../models/Asset'
import Entry from '../models/Entry'
import Author from '../models/Author'

import moment from 'moment';

class Article extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	getDate = (dateStr) => {
    	return moment(dateStr).format('dddd M.D');
  	}

  	getAuthor = (item) => {
  		if(item.authorName)
  		{
  			return (<h4><Icon type={'author-yellow'}/>{item.authorName}</h4>)
  		} else {
  			return (<Author id={item.author} render={
						(u) => (
					<h4><Icon type={'author-yellow'}/>{u.name}</h4>
				)}/>)
  		}
  	}

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;

		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className="Template  Template--default  Template--article">

					{/* Template-head */}
					<div className="Template-head">

						<div className="Template-intro Template-intro--short">
							<Media id={entry.image[0]} />


						</div>

					</div>
					{/* / Template-head */}

					<div className="Template-articleHead">
						<Content modifier="article">
							<h1>{entry.title}</h1>
							<h4>{entry.newsCategory}</h4>
						</Content>
					</div>

					{/* Template-body */}
					<div className="Template-body">



						<div className="Template-sections">
							<div className="Template-section Template-section--narrow">
								<div className="Template-heading">
									<Content modifier={'meta'}>
										<h4><Icon type={'calendar-yellow'}/>{this.getDate(entry.postDate) }</h4>
										{this.getAuthor(entry)}
										
									</Content>
								</div>
								<div className="Template-content">

									<Each items={entry.contentBlocks} render={
										(item) => {

											let aside,content;

											switch(item.type){

												case 'text':
													return (<Content modifier={'article'} html={item.text} />);
												break;
												case 'image':
													return (<Media fluid={false} id={item.image[0]} />);
												break;
												case 'pullQuote':
													return (<Content modifier={'article'} ><pullquote>"This is a pull quote"</pullquote></Content>);
												break;


											}

											return null;


										}

									}/>
								</div>
							</div>

							<Related to={entry} />
						</div>


					</div>
					{/* / Template-body */}


			</div>
			</FadeIn>
		);

	}
}

export default Article;



// WEBPACK FOOTER //
// ./src/js/templates/Article.js